import React from 'react';
import Input from '../../../components/ui/Input';

const CostStructureForm = ({ formData, onUpdate }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Fixed Monthly Expenses (₹)"
          type="number"
          placeholder="₹0"
          value={formData?.fixedExpenses || ''}
          onChange={(e) => onUpdate({ fixedExpenses: e?.target?.value })}
          required
        />

        <Input
          label="Variable Costs (₹)"
          type="number"
          placeholder="₹0"
          value={formData?.variableCosts || ''}
          onChange={(e) => onUpdate({ variableCosts: e?.target?.value })}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Marketing Spend Per Month (₹)"
          type="number"
          placeholder="₹0"
          value={formData?.marketingSpend || ''}
          onChange={(e) => onUpdate({ marketingSpend: e?.target?.value })}
          required
        />

        <Input
          label="Operational Overhead (₹)"
          type="number"
          placeholder="₹0"
          value={formData?.operationalOverhead || ''}
          onChange={(e) => onUpdate({ operationalOverhead: e?.target?.value })}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Debt / EMI Obligations (₹)"
          type="number"
          placeholder="₹0"
          value={formData?.debtObligations || ''}
          onChange={(e) => onUpdate({ debtObligations: e?.target?.value })}
          required
        />

        <Input
          label="Cash Reserve (Months)"
          type="number"
          placeholder="e.g., 6"
          value={formData?.cashReserve || ''}
          onChange={(e) => onUpdate({ cashReserve: e?.target?.value })}
          required
        />
      </div>

      <div className="p-4 bg-primary/10 border border-primary/20 rounded-md">
        <div className="flex items-start gap-3">
          <div className="p-2 bg-primary/20 rounded-md">
            <svg className="w-5 h-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <p className="text-sm font-medium text-foreground">System Calculations</p>
            <p className="text-xs text-muted-foreground mt-1">
              Based on your inputs, we'll calculate: Break-even point, Profit projection, Cash runway, and Risk exposure level
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CostStructureForm;